export function getAriaKey(paneKey: string): string | undefined {
  return `full-width-tab-${paneKey}`;
}
